import { render, staticRenderFns } from "./building-accordian.vue?vue&type=template&id=4247f2ed&"
import script from "./building-accordian.vue?vue&type=script&lang=js&"
export * from "./building-accordian.vue?vue&type=script&lang=js&"
import style0 from "./building-accordian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports